import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function CheckIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Check">
          <path
              fillRule="evenodd"
              d="M21.655 5.244a1 1 0 0 1 .1 1.411l-10.433 12.04a2.8 2.8 0 0 1-4.096.145l-4.933-4.933a1 1 0 1 1 1.414-1.414l4.933 4.933a.8.8 0 0 0 1.17-.042L20.244 5.345a1 1 0 0 1 1.41-.1Z"
              clipRule="evenodd"
          />
      </SvgIcon>
  );
}
